"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _MaterialIcon = _interopRequireDefault(require("@jobmatchme/ui/es/components/MaterialIcon"));

var _TranslatedMultiMap = _interopRequireDefault(require("../TranslatedMultiMap"));

var _Skeleton = _interopRequireDefault(require("@material-ui/lab/Skeleton"));

var _TranslatedKey = _interopRequireDefault(require("../TranslatedKey"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var successRate = 0.5;

var Skeleton = function Skeleton(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Skeleton.default, (0, _extends2.default)({
    className: _styleModule.default.skeleton
  }, props));
};

var JobofferCardLine = function JobofferCardLine(_ref) {
  var icon = _ref.icon,
      index = _ref.index,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? {} : _ref$text,
      status = _ref.status,
      diagnostic = _ref.diagnostic,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      discriminator = _ref.discriminator,
      distance = _ref.distance,
      _ref$matchingScore = _ref.matchingScore,
      matchingScore = _ref$matchingScore === void 0 ? 1 : _ref$matchingScore;

  var _useState = (0, _react.useState)(-1),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      averageFit = _useState2[0],
      setAverageFit = _useState2[1];

  var selectIcon = function selectIcon(icon, status, index, matchingScore, averageFit) {
    var thisClass = '';

    if (icon === 'favorite') {
      thisClass = averageFit >= successRate ? 'fullMatch' : averageFit < successRate && averageFit > 0 ? 'mediumMatch' : averageFit === 0 ? 'noMatch' : 'fullMatch';
    } else {
      thisClass = matchingScore >= 0.7 ? 'fullMatch' : 'mediumMatch';
    }

    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MaterialIcon.default, {
      icon: icon,
      className: (0, _classnames.default)(_styleModule.default.icon, _styleModule.default[status], _styleModule.default[thisClass])
    }, index);
  };

  var renderTranslation = function renderTranslation(text, averageFit, discriminator) {
    if (typeof text == 'string') {
      return text;
    } else if (text.tKey && text.tKey === 'favorite' && averageFit >= successRate) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TranslatedKey.default, (0, _extends2.default)({}, text, {
        discriminator: discriminator
      }));
    } else if (text.tKey && text.tKey === 'favorite' && averageFit < successRate) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TranslatedKey.default, (0, _extends2.default)({
        defaultText: true
      }, text, {
        discriminator: discriminator
      }));
    } else if (text.tKey && text.tKey !== 'favorite') {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TranslatedKey.default, (0, _extends2.default)({}, text, {
        discriminator: discriminator
      }));
    } else if (text.keys) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TranslatedMultiMap.default, (0, _extends2.default)({}, text, {
        discriminator: discriminator
      }));
    }

    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
  };

  (0, _react.useEffect)(function () {
    var getAverageFit = function getAverageFit() {
      var retValue = 0;
      var fitSumme = 0;

      if (diagnostic && diagnostic.itemsFit) {
        diagnostic.itemsFit.forEach(function (item) {
          fitSumme = fitSumme + (item.fit !== undefined ? item.fit : 0);
        });
        retValue = fitSumme / diagnostic.itemsFit.length;
      }

      return retValue;
    };

    if (averageFit === -1) {
      setAverageFit(getAverageFit());
    }
  }, [diagnostic, averageFit]);

  var getTextColor = function getTextColor(averageFit) {
    if (icon === 'favorite') {
      // currently we show for discriminator truck the diagnostic as a fullMatch
      if (discriminator === 'truck') {
        return 'dark';
      }

      return averageFit >= successRate ? 'high' : averageFit < successRate && averageFit > 0 ? 'medium' : averageFit === 0 ? 'empty' : 'dark';
    } else {
      return 'dark';
    }
  };

  return averageFit > -1 && (Array.isArray(text.keys) && text.keys.length || typeof text === 'string' || !Array.isArray(text.keys) && text.keys !== '' && !(typeof text.keys === 'undefined' && typeof text.label !== 'undefined')) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
      item: true,
      xs: 2,
      children: loading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(Skeleton, {
        width: "1.5rem",
        height: "1.5rem",
        variant: "circle",
        className: "".concat(_styleModule.default.skeleton, " ").concat(_styleModule.default.icon, " ").concat(_styleModule.default[status])
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "".concat(_styleModule.default[getTextColor(averageFit)], " ").concat(_styleModule.default.item),
        children: selectIcon(icon, status, index, matchingScore, averageFit, discriminator)
      })
    }, 'ic' + index), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
      item: true,
      xs: 10,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "".concat(_styleModule.default.textField, " ").concat(_styleModule.default[status]),
        children: loading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(Skeleton, {
          width: "".concat(Math.floor(Math.random() * 70) + 30, "%")
        }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          className: "".concat(_styleModule.default[getTextColor(averageFit)], " ").concat(_styleModule.default.item),
          children: [renderTranslation(text, averageFit, discriminator), distance]
        })
      })
    }, 'tx' + index)]
  });
};

var _default = /*#__PURE__*/(0, _react.memo)(JobofferCardLine);

exports.default = _default;